/* eslint-disable @typescript-eslint/no-floating-promises */
import React from "react";
import ReactDOM from "react-dom";
// import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "App";

import { MaterialUIControllerProvider } from "context";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// import sideBarEn from "./assets/i18next/en/sideBar";
// import sideBarFr from "./assets/i18next/fr/sideBar";
import translationEn from "./assets/i18next/en";
import translationFr from "./assets/i18next/fr";

i18next.use(LanguageDetector).init({
  interpolation: { escapeValue: false }, // React already does escaping
  // lng: "fr", // language to use
  fallbackLng: "fr",
  resources: {
    en: {
      translation: translationEn, // 'common' is our custom namespace
    },
    fr: {
      translation: translationFr,
    },
  },
  detection: {
    // Options for the language detector
    order: ["localStorage", "navigator"], // Detect from localStorage first, then browser settings
    caches: ["localStorage"], // Save the language to localStorage
  },
});

ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
serviceWorkerRegistration.register();
